/**
 * Full cascade lens - shows all lines with numbering
 */

import type { CascadeLens, Block } from '../types';

export const fullLens: CascadeLens = {
  id: 'full',
  name: 'Full Cascade',
  project: (_position: number, cascade: Block): string[] => {
    // Always return all lines without adding line numbers
    // (line numbers are added by the UI component)
    return cascade.lines;
  },
};